import { GraduationCap, Presentation, School } from "lucide-react";
import { SolutionGroupContent } from "./types";
import { pedagogicalSolutions } from "./smartLearning";

export const education: SolutionGroupContent = {
  key: "education",
  slug: "educacao",
  title: "Educação",
  titleKey: "header.solutions_menu.groups.education",
  icon: GraduationCap,
  tagline: "Tecnologia que aproxima escolas, professores e estudantes, da sala de aula à secretaria.",
  description: [
    "Redes de ensino e instituições de todos os portes precisam de ferramentas simples, seguras e que funcionem em qualquer dispositivo. A Calriz leva o ecossistema Google for Education e soluções pedagógicas para a rotina da escola, com implantação, formação e suporte.",
    "Do contrato à sala de aula: configuramos o ambiente, capacitamos as equipes e acompanhamos o uso para que a tecnologia vire aprendizagem de verdade, com dados protegidos e gestão centralizada.",
  ],
  concepts: ["Sala de aula", "Professores", "Gestão escolar", "Estudantes"],
  items: [
    {
      key: "google_workspace_edu",
      slug: "google-workspace-para-educacao",
      title: "Google Workspace para Educação",
      icon: School,
      tagline: "Colaboração, comunicação e sala de aula digital em um só ambiente, seguro e gerenciado pela instituição.",
      what: [
        "O Google Workspace for Education é o pacote de ferramentas do Google feito para escolas e universidades: Gmail, Drive, Documentos, Planilhas, Apresentações, Meet e o Google Classroom, a sala de aula virtual onde professores publicam atividades, recebem trabalhos e dão retorno aos estudantes.",
        "Tudo funciona no navegador, em Chromebooks, computadores ou celulares, com contas institucionais administradas pela escola. A versão gratuita (Education Fundamentals) já atende a maioria das redes; as edições pagas somam recursos avançados de segurança, análise e aulas por vídeo.",
      ],
      concepts: ["Classroom", "Drive e Docs", "Meet", "Console de admin"],
      benefits: [
        { title: "Sala de aula sem papel", text: "Atividades, prazos, correções e devolutivas organizados no Classroom, acessíveis de qualquer lugar." },
        { title: "Colaboração em tempo real", text: "Estudantes e professores editam o mesmo documento ao mesmo tempo, com histórico de versões." },
        { title: "Gestão centralizada", text: "A TI cria contas, define políticas e controla dispositivos em um único console." },
        { title: "Dados protegidos", text: "Sem anúncios nas contas educacionais e com controles alinhados à LGPD." },
      ],
      steps: [
        { title: "Diagnóstico e licenciamento", text: "Avaliamos a rede, validamos o domínio e indicamos a edição certa (Fundamentals, Standard ou Plus)." },
        { title: "Implantação", text: "Criação das contas, unidades organizacionais, políticas de segurança e migração de e-mails e arquivos." },
        { title: "Formação", text: "Oficinas práticas para gestores, professores e equipe de TI, com foco no uso pedagógico." },
        { title: "Acompanhamento", text: "Suporte contínuo e relatórios de adoção para medir o uso e ajustar a estratégia." },
      ],
      audience: ["Redes municipais e estaduais de ensino", "Escolas particulares", "Universidades e institutos federais", "Secretarias de educação"],
    },
    {
      key: "training",
      slug: "capacitacao-e-treinamento",
      title: "Capacitação e Treinamento",
      icon: Presentation,
      tagline: "Formação prática para que professores, gestores e equipes técnicas tirem o máximo da tecnologia.",
      what: [
        "Tecnologia só transforma quando as pessoas sabem usá-la com confiança. Nossos programas de capacitação combinam oficinas presenciais, trilhas on-line e acompanhamento em sala para levar as ferramentas digitais para a prática de cada perfil da instituição.",
        "Os conteúdos vão do uso básico das ferramentas Google até metodologias ativas, IA na prática pedagógica e preparação para as certificações oficiais (Google Certified Educator e Trainer), sempre adaptados à realidade da rede.",
      ],
      concepts: ["Oficinas", "Trilhas on-line", "Certificações", "Mentoria"],
      benefits: [
        { title: "Adoção de verdade", text: "Licenças e equipamentos passam a ser usados no dia a dia, e não ficam parados." },
        { title: "Conteúdo sob medida", text: "Trilhas diferentes para professores, coordenação, gestão e TI." },
        { title: "Professores certificados", text: "Preparação para as certificações Google for Education, que valorizam a equipe." },
        { title: "Resultados medidos", text: "Presença, avaliação e indicadores de uso acompanhados em relatórios." },
      ],
      steps: [
        { title: "Levantamento", text: "Mapeamos o nível de cada grupo e os objetivos pedagógicos da instituição." },
        { title: "Plano de formação", text: "Definimos trilhas, carga horária, formato (presencial, on-line ou híbrido) e cronograma." },
        { title: "Execução", text: "Oficinas mão na massa com especialistas e materiais de apoio para continuar depois." },
        { title: "Multiplicação", text: "Formamos multiplicadores internos e acompanhamos os resultados na rotina." },
      ],
      audience: ["Professores e coordenadores pedagógicos", "Gestores escolares", "Equipes de TI", "Secretarias de educação"],
    },
    pedagogicalSolutions,
  ],
};
